import 'chartjs-plugin-zoom';

export let PieIncassoAggregatoData = {
    labels: ["Salumeria"],
    datasets: [
        {
            label: "Incassi",
            data: [100],
            backgroundColor: ['rgba(255, 99, 132, 0.2)'],
        }
    ]
  };

export let PieIncassoAggregatoOptions = {
  responsive: true, 
  maintainAspectRatio: true,  
}

export let LineIncassoAggregatoData = {
    labels: [],
    datasets: []
  };

export let LineIncassoAggregatoOptions = {
  responsive: true, 
  maintainAspectRatio: true,  
}